import useAppModernisation from "../../../hooks/useAppModernisation";
import useScreenSize from "../../../hooks/useScreenSize";
import GuidelineOverviewApp from "./GuidelineOverviewApp";
import GuidelineOverview from "./GuidelineOverview";

const GuidelineOverviewRouter = () => {
  const { isMobileView } = useAppModernisation();
  const { isTabletSize } = useScreenSize();

  if ( isMobileView || isTabletSize ) {
    return <GuidelineOverviewApp />
  } else {
    return <GuidelineOverview />
  }
}

export default GuidelineOverviewRouter;